import React, { useState } from 'react';
import { CButton, CFormInput, CFormLabel } from '@coreui/react';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import { callTokenApi } from '../../../../apiCaller';
import { toast } from 'react-toastify';
import CIcon from '@coreui/icons-react';
import { cilCopy, cilCheckCircle } from '@coreui/icons';

const sampleJson = {
     id: 496117361,
     match: 'exact',
     name: {
          full: 'Lew Salvetta',
          first: 'Lew',
          middle: 'None',
          last: 'Salvetta',
          nickname: 'None',
          suffix: 'None',
          title: 'None',
     },
     company: 'None',
     linkedin: {
          id: 476995021,
          url: 'https://linkedin.com/in/lew-salvetta-9518b2113',
          name: {
               full: 'Lew Salvetta',
               first: 'Lew',
               middle: 'None',
               last: 'Salvetta',
               nickname: 'None',
               suffix: 'None',
               title: 'None',
          },
          headline: 'Manager at Smw',
          org: 'Smw',
          title: 'Manager',
          dob: 'None',
          slug_status: 'A',
          location: {
               text: 'Sheboygan Falls Town, Wisconsin, United States',
               country: 'None',
               city: 'None',
               region: 'None',
               district: 'None',
          },
          industry: { id: 101, name: 'Fundraising' },
          country: 'US',
          profile_pic: 'None',
          connections: 1,
          num_recommenders: 'None',
          skills: [],
          summary: 'None',
          positions: [
               {
                    id: 'None',
                    company_id: 'None',
                    company_name: 'Smw',
                    title: 'Manager',
                    is_current: true,
                    summary: 'None',
                    start_date: 'None',
                    start_date_year: 'None',
                    start_date_month: 'None',
                    end_date: 'None',
                    end_date_year: 'None',
                    end_date_month: 'None',
                    seniority: [
                         { id: 16, seniority: 'Mid-Senior level' },
                         { id: 21, seniority: 'Not Applicable' },
                         { id: 13, seniority: 'Associate' },
                    ],
                    job_function: [
                         { id: 60, job_function: 'Other' },
                         { id: 54, job_function: 'Customer Service' },
                    ],
                    employment_type: [{ id: 22, job_employment_type: 'Full-time' }],
                    academic_qualification: [{ id: 815, academic_qualification: 'Bachelor Degree' }],
               },
          ],
          education: [],
          volunteering: [],
          languages: [],
          certifications: [],
          projects: [],
          recommendations: [],
          updated_date: '2025-02-19',
          seniority: [
               { id: 16, seniority: 'Mid-Senior level' },
               { id: 21, seniority: 'Not Applicable' },
               { id: 13, seniority: 'Associate' },
          ],
          job_function: [
               { id: 60, job_function: 'Other' },
               { id: 54, job_function: 'Customer Service' },
          ],
          employment_type: [{ id: 22, job_employment_type: 'Full-time' }],
          academic_qualification: [{ id: 815, academic_qualification: 'Bachelor Degree' }],
     },
     indeed: 'None',
     directdials: ['+15074544957', '+19203823836', '+19208890069'],
     twitter: {
          id: 94922402,
          url: 'https://twitter.com/girl_lews',
          slug: 'girl_lews',
          name: {
               full: 'girl',
               first: 'Girl',
               middle: 'None',
               last: 'None',
               nickname: 'None',
               suffix: 'None',
               title: 'None',
          },
          signup_at: '2012-10-10',
          follower_count: 1,
     },
     gplus: 'None',
     github: 'None',
     emails: [
          {
               email: '',
               domain: '',
               tags: ['b2b'],
          },
     ],
};

const EnrichmentData = () => {
     const [script, setScript] = useState('');
     const [sessionId, setSessionId] = useState('');
     const [isRunning, setIsRunning] = useState(false);
     const [scriptResult, setScriptResult] = useState('');
     const [copiedScript, setCopiedScript] = useState(false);

     const handleLoadSample = () => {
          setScript(JSON.stringify(sampleJson, null, 4));
     };

     const handleBeautifyJson = () => {
          try {
               // Try to parse the script as JSON
               const parsed = JSON.parse(script);
               // Format it with 4-space indentation
               const beautified = JSON.stringify(parsed, null, 4);
               setScript(beautified);
          } catch (error) {
               toast.error('Invalid JSON format. Please check your syntax.');
          }
     };

     const handleCopyScript = async () => {
          try {
               await navigator.clipboard.writeText(script);
               setCopiedScript(true);
               setTimeout(() => setCopiedScript(false), 2000);
          } catch (error) {
               toast.error('Failed to copy to clipboard');
          }
     };

     const handleClearEditor = () => {
          setScript('');
          setScriptResult('');
     };

     const handleRunScript = async () => {
          if (!sessionId.trim()) {
               toast.error('Please enter a Session ID');
               return;
          }

          setIsRunning(true);
          setScriptResult('');

          try {
               const response = await callTokenApi('admin/centralized-person/add-enrichment-data', 'POST', {
                    sessionId,
                    script: JSON.parse(script),
               });
               if (response.status === 200) {
                    toast.success('Enrichment data saved successfully!');
                    setScriptResult(response.data.result || 'Data saved successfully');
               } else {
                    toast.error(response);
               }
          } catch (error) {
               console.error('API call failed:', error);
               toast.error('An unexpected error occurred while saving enrichment data.');
          } finally {
               setIsRunning(false);
          }
     };
     return (
          <>
               {' '}
               <div className='d-flex justify-content-between align-items-center mb-4'>
                    <div className='d-flex align-items-center gap-2'>
                         <CFormLabel htmlFor='sessionId' className='mb-0 me-2'>
                              Session ID:
                         </CFormLabel>
                         <CFormInput
                              type='text'
                              id='sessionId'
                              placeholder='Enter Session ID'
                              value={sessionId}
                              onChange={(e) => setSessionId(e.target.value)}
                              style={{ width: '400px', height: '32px' }}
                              size='sm'
                         />
                    </div>

                    <div className='d-flex align-items-center gap-2'>
                         <CButton
                              size='sm'
                              color='secondary'
                              variant='outline'
                              onClick={handleLoadSample}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px' }}
                         >
                              Load Sample
                         </CButton>
                         <CButton
                              size='sm'
                              color='info'
                              variant='outline'
                              onClick={handleBeautifyJson}
                              disabled={!script.trim()}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px' }}
                         >
                              Beautify JSON
                         </CButton>
                         <CButton
                              size='sm'
                              color='success'
                              variant='outline'
                              onClick={handleCopyScript}
                              disabled={!script.trim()}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '100px', transform: 'unset' }}
                         >
                              <CIcon icon={copiedScript ? cilCheckCircle : cilCopy} className='me-2' />
                              {copiedScript ? 'Copied!' : 'Copy JSON'}
                         </CButton>
                         <CButton
                              size='sm'
                              color='danger'
                              variant='outline'
                              onClick={handleClearEditor}
                              disabled={!script.trim() && !scriptResult}
                              className='d-flex align-items-center justify-content-center'
                              style={{ height: '32px', minWidth: '80px' }}
                         >
                              Clear
                         </CButton>
                    </div>
               </div>
               <AceEditor
                    mode='json'
                    theme='monokai'
                    name='scriptEditor'
                    onChange={setScript}
                    value={script}
                    showPrintMargin={false}
                    editorProps={{ $blockScrolling: true }}
                    setOptions={{
                         enableBasicAutocompletion: true,
                         enableLiveAutocompletion: true,
                         enableSnippets: true,
                         showLineNumbers: true,
                         tabSize: 4,
                         useWorker: false,
                    }}
                    fontSize={14}
                    lineHeight={20}
                    style={{ width: '100%', height: '500px' }}
               />
               <div className='d-flex justify-content-end mt-3'>
                    <CButton color='primary' onClick={handleRunScript} disabled={isRunning || !script.trim()}>
                         {isRunning ? 'Waiting...' : 'Add'}
                    </CButton>
               </div>
          </>
     );
};

export default EnrichmentData;
